// extracted by mini-css-extract-plugin
module.exports = {"registerLoginButtons":"RegisterLoginButtons_registerLoginButtons__3PlZS"};